module.exports = __webpack_public_path__ + "static/massage-img-4440fd23beb3ecb4281aff50d2791691.jpeg";